module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Navbar', {
    attrs: {
      "tabs": _vm.tabs,
      "dropdown-tabs": _vm.dropdownTabs,
      "currentApp": 'ia'
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b278e2e4!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/ia/IaApp.vue
// module id = 1110
// module chunks = 0